export default {
  name: "CalendarSuccessSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28 6h-3.5V3.5a1.5 1.5 0 1 0-3 0V6h-11V3.5a1.5 1.5 0 1 0-3 0V6H4c-1.16 0-2 .84-2 2v20c0 1.16.84 2 2 2h24c1.16 0 2-.84 2-2V8c0-1.16-.84-2-2-2zm-5.8 8.82-6.11 8.08a1.5 1.5 0 0 1-2.14.26l-4.89-3.98a1.5 1.5 0 0 1-.22-2.11 1.5 1.5 0 0 1 2.11-.22l3.68 2.99L19.81 13a1.5 1.5 0 1 1 2.39 1.82z",
  },
}
